import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8333 16.2461L2.5 19.2461V24.2461H30.5V13.2461L21.1667 19.2461L11.8333 16.2461Z"
      className="number-fill"
      fill="currentColor"
    />
    <path
      d="M7.1179 11.6268V10.3697L10.4545 4.51882H11.9844L8.72443 10.2589V10.3271H13.9062V11.6268H7.1179ZM11.2812 13.2461V11.256L11.3153 10.6808V7.79155H12.7685V13.2461H11.2812ZM15.5849 13.3398C15.3264 13.3398 15.1048 13.2489 14.9202 13.0671C14.7355 12.8853 14.6446 12.6637 14.6474 12.4023C14.6446 12.1467 14.7355 11.9279 14.9202 11.7461C15.1048 11.5643 15.3264 11.4734 15.5849 11.4734C15.8349 11.4734 16.0523 11.5643 16.2369 11.7461C16.4244 11.9279 16.5196 12.1467 16.5224 12.4023C16.5196 12.5756 16.4741 12.7333 16.3861 12.8754C16.3008 13.0174 16.1872 13.131 16.0452 13.2163C15.906 13.2987 15.7525 13.3398 15.5849 13.3398ZM17.7728 10.4379C17.7785 10.1424 17.8197 9.84553 17.8964 9.54723C17.976 9.24609 18.101 8.92791 18.2714 8.59268C18.4419 8.25462 18.6649 7.88246 18.9405 7.47621L20.9433 4.51882H22.5626L20.3851 7.70632C20.4902 7.67791 20.5995 7.65518 20.7132 7.63814C20.8268 7.61825 20.9433 7.60831 21.0626 7.60831C21.5939 7.60831 22.0669 7.72905 22.4816 7.97053C22.8993 8.212 23.2274 8.54581 23.466 8.97195C23.7047 9.39808 23.824 9.88814 23.824 10.4421C23.824 11.0188 23.6933 11.5273 23.4319 11.9677C23.1734 12.4052 22.8169 12.7475 22.3623 12.9947C21.9106 13.2418 21.3964 13.3654 20.8197 13.3654C20.2544 13.3654 19.7402 13.2461 19.2771 13.0075C18.8169 12.7688 18.4504 12.4308 18.1777 11.9933C17.9049 11.5558 17.77 11.0373 17.7728 10.4379ZM19.3112 10.4719C19.3112 10.7873 19.3737 11.0671 19.4987 11.3114C19.6265 11.5558 19.8027 11.7475 20.0271 11.8867C20.2544 12.0259 20.5157 12.0955 20.8112 12.0955C21.1038 12.0955 21.3623 12.0273 21.5868 11.891C21.8112 11.7518 21.9873 11.5614 22.1152 11.32C22.243 11.0756 22.3069 10.7958 22.3069 10.4805C22.3069 10.1651 22.243 9.88672 22.1152 9.64524C21.9873 9.40092 21.8112 9.21058 21.5868 9.07422C21.3623 8.93501 21.1038 8.86541 20.8112 8.86541C20.5157 8.86541 20.2544 8.93359 20.0271 9.06996C19.8027 9.20632 19.6265 9.39524 19.4987 9.63672C19.3737 9.8782 19.3112 10.1566 19.3112 10.4719Z"
      className="graph-fill"
      fill="currentColor"
    />
  </svg>,
  'StatChartIcon'
);

export const StatChartIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.number-fill': {
          color: theme.palette.status.success.highContrast,
        },
        '.graph-fill': {
          color: theme.palette.status.success.main,
        },
      })}
    />
  );
};
